// extracted by mini-css-extract-plugin
export default {"eventPageBody":"eventPage_eventPageBody__hUvcG","eventContainer":"eventPage_eventContainer__IheYE"};